import { FontIcon, Icon } from "@fluentui/react";
import { ColumnsType } from "antd/es/table";
import IsDataNull from "../../Template/IsDataNull";
import ActionColumn from "./ActionColumn";
import ShortenedName from "./ShortenedName";
import TableHeader from "./TableHeader";

export interface EngageTranslationQCTableColumnProperties {
  id: number;
  documentId: number;
  name: string;
  engageProductionId: string;
  format: string;
  pages: number;
  client: string;
  sourceLanguage: string;
  outputLanguage: string;
  isLocked: boolean;
  assignedTo: string;
  owner: string;
  ownerEmail: string;
  status: "New" | "Processing" | "Failed" | "QC Ready" | "QC in Progress";
  uploadType?: string;
}
const EngageTranslationQCTableColumns: ColumnsType<EngageTranslationQCTableColumnProperties> = [
  {
    title: <TableHeader title="ID" />,
    dataIndex: "displayId",
    key: "id",
    sorter: true,
    defaultSortOrder: "descend",
    width: 100,
  },
  {
    title: <TableHeader title="Document" />,
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: "8%",
    render: (data) => {
      const maxLength = 30;

      if (data.length > maxLength) {
        return (
          <ShortenedName
            data={data}
            maxLength={maxLength}
            toolTipText={data}
          />
        );
      } else {
        return <IsDataNull data={data} />;
      }
    },
  },
  {
    title: <TableHeader title="Engage ID" />,
    key: "engageProductionId",
    dataIndex: "engageProductionId",
    sorter: true,
    width: 150,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Format" />,
    dataIndex: "format",
    key: "format",
    sorter: true,
    width: 100,
    render: (data) => {
      if (data === "pdf") {
        return <FontIcon iconName="PDF" />;
      } else if (data === "docx" || "doc") {
        return <FontIcon iconName="WordDocument" />;
      } else {
        <IsDataNull data={data} />;
      }
    },
  },
  {
    title: <TableHeader title="Pages" />,
    key: "pages",
    dataIndex: "pages",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Client" />,
    dataIndex: "client",
    width: 150,
    sorter: true,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Source Language" />,
    key: "sourceLanguage",
    dataIndex: "sourceLanguage",
    sorter: true,
    width: 200,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Output Language" />,
    key: "outputLanguage",
    dataIndex: "outputLanguage",
    sorter: true,
    width: 200,
    render: (data) => <IsDataNull data={data} />,
  },
  // {
  //   title: <TableHeader title="Assigned To" />,
  //   key: "qcAssignedTo",
  //   dataIndex: "qcAssignedTo",
  //   width: 150,
  //   sorter: true,
  //   render: (data) => {
  //     const maxLength = 30;

  //     // if (data.length > maxLength) {
  //     //   return (
  //     //     <ShortenedName
  //     //       data={data}
  //     //       maxLength={maxLength}
  //     //       toolTipText={data}
  //     //     />
  //     //   );
  //     // } else {
  //     return <IsDataNull data={data} />;
  //     // }
  //   },
  // },
  {
    title: <TableHeader title="Owner" />,
    key: "owner",
    dataIndex: "owner",
    width: "10%",
    sorter: true,
    render: (data, record) => {
      const maxLength = 25;

      return (
        record.owner && (
          <ShortenedName
            data={record.owner}
            maxLength={maxLength}
            toolTipText={record.ownerEmail}
          />
        )
      );
    },
  },

  {
    title: <TableHeader title="Workflow Coordinator" />,
    key: "workflowCoordinator",
    dataIndex: "workflowCoordinator",
    width: 200,
    sorter: true,
    render: (data) => {
      const maxLength = 30;

      if (data.length > maxLength) {
        return (
          <ShortenedName
            data={data}
            maxLength={maxLength}
            toolTipText={data}
          />
        );
      } else {
        return <IsDataNull data={data} />;
      }
    },
  },
  {
    title: <TableHeader title="Status" />,
    dataIndex: "status",
    key: "status",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Actions" />,
    key: "action",
    dataIndex: "action",
    width: 125,
    align: "center",
    render: (value, record) => {
      return (
        <ActionColumn
          type="quality-control"
          record={record}
        />
      );
    },
  },
];

export default EngageTranslationQCTableColumns;
